import { KeyCode, Patterns } from './types';

export const keyCode: KeyCode = {
  BACKSPACE: 'Backspace',
  ENTER: 'Enter',
  LEFT_ARROW_COMPATIBILITY: 'Left',
  LEFT_ARROW: 'ArrowLeft',
  UP_ARROW_COMPATIBILITY: 'Up',
  UP_ARROW: 'ArrowUp',
  RIGHT_ARROW_COMPATIBILITY: 'Right',
  RIGHT_ARROW: 'ArrowRight',
  DOWN_ARROW_COMPATIBILITY: 'Down',
  DOWN_ARROW: 'ArrowDown'
};

export const patterns: Patterns = {
  number: /^$|^([\d])$/,
  text: /^$|^(.)$/,
  password: /^$|^(.)$/
};
